/**
 * Validates a logon name in the format "domain\samAccountName".
 */
function validateDownLevelLogonName(value: string): boolean {
    return /^[^\\]+\\[^\\]+$/.test(value);
}

export default validateDownLevelLogonName;
